import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { ReceiptCheckItem } from "../../domain/models/receipt-check";
import { LoadToBeStoredItems } from "../../domain/usecases/load-to-be-stored-items";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbLoadToBeStoredItems implements LoadToBeStoredItems {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async load(warehouseId: number): Promise<ReceiptCheckItem[]> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "get",
      params: { warehouseId },
    });
    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
